import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import {ToastParams} from './toast.module';
import {GlobalEventsService} from 'src/app/services/global-events.service';
import {debounceTime, takeUntil} from 'rxjs/operators';
import {BehaviorSubject, ReplaySubject, timer} from 'rxjs';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss']
})
export class ToastComponent implements OnInit, OnDestroy, AfterViewInit {

  private _params: ToastParams;
  private defaultPos = {bottom: '60px', right: '5px'};
  public currentPos:{[key: string]: string} = this.defaultPos;
  private destroy$: ReplaySubject<boolean> = new ReplaySubject<boolean>();
  private isHiding:boolean = false;
  classes: string;

  @Input()
  autoHide = true;

  @Input()
  autoHideDelay = 5000;

  private hideTimeout;

  @Input()
  set params(val: ToastParams) {
    this.hideNotification(true);
    Object.keys(val).forEach(key => {
      this._params[key] = val[key];
    });

    if (this._params.autoHideDelay) {
      this.autoHideDelay = this._params.autoHideDelay;
    }

    this.currentPos = this.defaultPos;
    if (this._params.position) {
      this.currentPos = this._params.position;
    }

    if (this._params.hasOwnProperty('autoHide')) {
      this.autoHide = this._params.autoHide;
    }

    if (this._params.classes.length > 0) {
      this.classes = this._params.classes.join(' ');
    } else {
      this.classes = '';
    }
  }

  get params(): ToastParams {
    return this._params;
  }

  @ViewChild('toastTpl', {static: false, read: ElementRef}) toastTemplate: ElementRef;

  constructor(private eventService: GlobalEventsService, private chRef: ChangeDetectorRef) {
    this._params = {isHeader: true, title: '', subtitle: null, message: '', classes: []};
  }

  isClasses(){
    return this.classes && this.classes.length > 0;
  }

  ngOnInit() {
    this.eventService.ToastNotificationEvent
      .pipe(takeUntil(this.destroy$))
      .pipe(debounceTime(300))
      .subscribe((event: ToastParams) => {
        if (!event.message || event.message.trim().length == 0){
          jQuery(this.toastTemplate.nativeElement).toast('hide');
          timer(300).subscribe(()=>{
            this.onToastUpdated(event)
          })
          return;
        }

        this.onToastUpdated(event);
        this.chRef.detectChanges();
      });
  }

  private onToastUpdated(event){
    this.params = event;
    if (this.params.message && this.params.message.trim().length > 0) {
      this.showNotification();
    }
    else {
      this.hideNotification();
    }

  }

  ngAfterViewInit() {
    this.hideNotification();
  }

  ngOnDestroy() {
    this.hideNotification();
    this.destroy$.next(true);
  }

  showNotification(): void {
    const elm = jQuery(this.toastTemplate.nativeElement);
    if (this.isHiding){
      timer(100).subscribe(()=>{
        this.showNotification()
      });
      return;
    }

    elm.toast('show');

    if (this.autoHide) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = setTimeout(() => {
        this.hideNotification();
      }, this.autoHideDelay);
    }
    this.chRef.detectChanges();
  }

  hideNotification(dontUseTimeout?): void {
    if (this.isHiding){
      return;
    }
    let $element = jQuery(this.toastTemplate.nativeElement);
    $element.toast('hide');
    if (!dontUseTimeout){
      this.isHiding=true;
      timer(300).subscribe(()=>{
        this.isHiding = false;
      })
    }
    this.autoHide = true;
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }
    this.chRef.detectChanges();
  }

}
